// extracted by mini-css-extract-plugin
module.exports = {"background":"login__background","formPanel":"login__formPanel","header":"login__header","logo":"login__logo"};